export default "__VITE_ASSET__DbSCKPsv__"